<template>
  <div class="mobile_change_making">
    <div class="mySwitch">
      <!-- 显示当前选中项的图片 -->
      <img
        v-if="currentItem"
        style="width: 315px; height: 192px; margin: 20px 0"
        :src="currentItem.url"
        alt=""
      />
      <!-- 显示当前选中项的文字信息 -->
      <div class="slider-container">
        <!-- 左箭头 -->
        <div
          class="arrow left"
          @click="moveLeft"
          :style="{
            opacity: currentIndex === 0 ? 0.3 : 1,
            display: currentIndex === 0 ? 'none' : 'block',
          }"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <!-- 外部容器，固定宽度并溢出隐藏 -->
        <div class="outer-box production_switch_scroll" ref="outerBox">
          <!-- 内部容器，根据数据渲染 -->
          <div
            class="inner-box"
            ref="innerBox"
            :style="{ transform: `translateX(-${offset}px)` }"
          >
            <div
              v-for="item in navItems"
              :key="item.id"
              class="item"
              :class="{ active: currentItem && item.id === currentItem.id }"
              @click="selectItem(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- 右箭头 -->
        <div
          class="arrow right"
          @click="moveRight"
          :style="{
            opacity: canScrollRight() ? 1 : 0.3,
            display: canScrollRight() ? 'block' : 'none',
          }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="SwitchText" v-if="currentItem">{{ currentItem.msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          id: "001",
                    title: "Lens Measurement and Positioning Process",

          msg: "Automatically calculate and complete the measurement data file within 5 minutes.Precisely align the virtual camera in the 3D world with the real camera coordinates on-site, ensuring no distortion.",
          url: 'https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png',
        },
        {
          id: "002",
                   title: "Latency Calibration",

          msg: "Measure camera delay, media delay, and manually adjust tracking delay to ensure perfect synchronization between the screen and extended visuals, eliminating issues such as stuttering and tearing.",
          url: 'https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png',
        },
        {
          id: "003",
                   title: "Color Calibration",

          msg: "Automatically calculate calibration files by comparing the colors captured by the camera on the LED screen and the original input, ensuring accurate color matching between the screen and extended visuals.",
          url: 'https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png',
        },
        {
          id: "004",
                    title: "Multi-camera switching",

          msg: "When the number of tracking systems is perfectly matched to the cameras, the director can seamlessly switch between tracking positions in real time, capturing a dynamic range of visuals to convey a rich and varied visual language.",
          url: 'https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png',
        },
        {
          id: "005",
                    title: "Engine Level/Sequence Management",

          msg: "Link multiple virtual scene programs added to the Server-C server timeline with their corresponding scene levels in Unreal Engine, enabling instant control and triggering of sequence animations within the virtual scenes.",
          url: 'https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png',
        },
        {
          id: "006",
                    title: "Virtual and Real Lighting Synchronization Control",

          msg: "Construct the lighting layout of the real studio based on the virtual scene's lighting configuration. hecoos uses the ART-NET protocol to directly control real lights, achieving synchronized interaction between virtual and real lighting",
          url: 'https://download.hecoos.com/enlightv/2025-17/be90db821f444481cb55fef8a09dbce3.png',
        },
        {
          id: "007",
                    title: "Rivermax Cluster Rendering",

          msg: "Share the rendered view of the inner frustum across cluster nodes to optimize resource usage and avoid rendering inefficiencies. By distributing tasks across multiple nodes, the visual quality is enhanced, and the performance remains smoother.The SMPTE 2110 synchronization strategy is applied to frame-lock each rendering node, ensuring seamless synchronization between the Unreal Engine output and the camera feed.",
          url: 'https://download.hecoos.com/enlightv/2025-37/d92591f17ac050bb0e27402e12edd0cf.png',
        },
      ],
      currentIndex: 0,
      offset: 0,
      visibleItems: 0,
      currentItem: null,
      totalWidth: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        this.currentItem = this.navItems[0];
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      }
    });
  },
  methods: {
    moveLeft() {
      if (this.currentIndex > 0) {
        const prevItem = this.$refs.innerBox.children[this.currentIndex - 1];
        const moveWidth = prevItem.offsetWidth + 20;
        this.offset = Math.max(0, this.offset - moveWidth);
        this.currentIndex--;
      }
    },
    moveRight() {
      if (this.canScrollRight()) {
        const currentItem = this.$refs.innerBox.children[this.currentIndex];
        const moveWidth = currentItem.offsetWidth + 20;
        this.offset += moveWidth;
        this.currentIndex++;
      }
    },
    selectItem(item) {
      this.currentItem = item;
    },
    calculateVisibleItems() {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        const outerBoxWidth = this.$refs.outerBox.offsetWidth;
        let totalWidth = 0;
        let visibleCount = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          totalWidth += items[i].offsetWidth;
          if (i > 0) {
            totalWidth += 20;
          }
          if (totalWidth <= outerBoxWidth) {
            visibleCount++;
          } else {
            break;
          }
        }
        this.visibleItems = visibleCount;
      }
    },
    calculateTotalWidth() {
      if (this.$refs.innerBox) {
        let total = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          total += items[i].offsetWidth;
          if (i > 0) {
            total += 20;
          }
        }
        this.totalWidth = total;
      }
    },
    getVisibleWidth() {
      return this.$refs.outerBox ? this.$refs.outerBox.offsetWidth : 0;
    },
    canScrollRight() {
      if (!this.$refs.innerBox) return false;
      const outerBoxWidth = this.getVisibleWidth();
      const lastItem =
        this.$refs.innerBox.children[this.$refs.innerBox.children.length - 1];
      const lastItemRight = this.totalWidth - lastItem.offsetWidth - 20;
      return (
        this.offset + outerBoxWidth < lastItemRight + lastItem.offsetWidth + 20
      );
    },
  },
  watch: {
    "$el.clientWidth": {
      handler() {
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";

</style>
